import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";

const viewAssessmentReport = (userGUID, assessmentAttemptId) => {
  return function () {
    return AssessmentServiceApi.viewAssessmentReport(
      userGUID,
      assessmentAttemptId
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export { viewAssessmentReport };
